import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/$slug/fleet/$aircraftId/_aircraft/expenses",
)({
  staticData: { title: "Expenses Summary" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/fleet/[aircraftId]/expenses/expenses.tsx"),
    "Expenses",
  ),
})
